import { css } from '@compiled/react';

import { wacToken } from '@/libraries/design/foundations';

import type { ResultsCountProps } from '../types';

/**
 * Visible "N results" line. Text arrives pre-localised; CSS uppercases it.
 * `role="status"` + `aria-live="polite"` announce the new count after a
 * filter change (parity with the visually-hidden live region at
 * `filterable-gallery.tsx:457-465` — ours is just visible instead of hidden).
 */
export const ResultsCount = ({ text }: ResultsCountProps) => {
	return (
		<p role="status" aria-live="polite" css={countStyle}>
			{text}
		</p>
	);
};

const countStyle = css({
	fontFamily: wacToken('font.charlie.text'),
	fontSize: '12px',
	lineHeight: '18px',
	fontWeight: 400,
	textTransform: 'uppercase',
	color: wacToken('color.neutral.light700'),
	margin: 0,
});
